import React from "react"
import PropTypes from "prop-types"

const IconButton = (props) => {
  return (
    <button
      className={props.styles}
      type="button"
      disabled={props.disabled}
      onClick={props.onClick}>
      <span className={`icon ${props.icon}`} />
    </button>
  )
}

IconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  styles: PropTypes.string,
}

export default IconButton
